import React from 'react';
import PropTypes from 'prop-types';
import ProgressiveImage from "react-progressive-image";
import assets from "../../../../../util/assets";
import {getStatus} from "../../../../../util/utility";
import {Button} from "reactstrap";
import "./index.css";
import {getEncryptedIdForBroadcaster} from "../../../../../util/broadcast_util";

SubscriptionListItem.propTypes = {
    item: PropTypes.object.isRequired,
    cancel_subscription: PropTypes.object.isRequired,
    renew_subscription: PropTypes.object.isRequired,
    cancelSubscription: PropTypes.func.isRequired,
    renewSubscription: PropTypes.func.isRequired,
};

const getBtnText = (props) => {
    if (props.item.cancelled_at === null) {
        return "CANCEL";
    } else {
        return "RENEW";
    }
}

function SubscriptionListItem(props) {
    return (
        <div className="subscription-list-container">
            <div className="display-flex">
                <ProgressiveImage
                    delay={1000}
                    src={props.item.broadcaster.profile_pic}
                    placeholder="placeholder">

                    {(src, loading) => {
                        return loading ? (
                                <img alt="broadcaster profile picture"
                                     className="subscription-list-container-user-section-profile-pic"
                                     src={assets.user_placeholder}/>
                            ) :
                            (
                                <div
                                    className="subscription-list-container-user-section-profile-pic"
                                    style={{backgroundImage: "url('" + props.item.broadcaster.profile_pic + "')"}}>

                                    <img
                                        src={props.item.broadcaster.is_verified === 1 ? assets.clipstore.home.broadcaster_verified : assets.clipstore.home.broadcaster_unverified}
                                        alt="verified broadcaster"/>
                                </div>
                            )

                    }}
                </ProgressiveImage>
                <div className="subscription-list-container-column2">
                    <div className="subscription-list-container-broadcaster-name"
                         onClick={() => {
                             const encryptBroadcasterId = getEncryptedIdForBroadcaster(props.item.broadcaster.id)
                             props.history.push(`/profile/${encryptBroadcasterId}`);
                         }}>
                        <span>{props.item.broadcaster.username}</span>
                        <img src={getStatus(props.item.broadcaster.status)}
                             className="broadcaster-profile-status-img"
                             alt="broadcaster status"/>
                    </div>
                    <div>
                    <span className="subscription-list-container-subscribers-count" style={{paddingLeft: 0}}>
                        {`${props.item.broadcaster.subscriber_count} Subscribers`}
                    </span>
                        <span>&#8226;</span>
                        <span className="subscription-list-container-subscribers-count">
                        {`${props.item.broadcaster.followers_count} Followers`}
                    </span>
                    </div>
                    <div className="subscription-list-container-billing-text">{props.item.status}</div>
                </div>
            </div>
            <div className="subscription-list-container-amount-formatted">
                {props.item.amount_formatted}
            </div>
            <div style={{marginLeft: 16, marginRight: 16}}>
                <Button color="outline-primary"
                        onClick={() => {
                            if(!(props.cancel_subscription.isFetching || props.renew_subscription.isFetching)){
                                if (getBtnText(props) === "CANCEL") {
                                    console.log("call cancel")
                                    props.cancelSubscription(props.item.id);
                                } else {
                                    console.log("call renew")
                                    props.renewSubscription(props.item.id);
                                }
                            }
                        }}>
                    {
                        (props.cancel_subscription.isFetching || props.renew_subscription.isFetching)
                            ?
                            <img
                                src={assets.loading_blue}
                                alt={"Loading"}
                                width={26}
                                height={26}
                            />
                            :
                            getBtnText(props)
                    }

                </Button>
            </div>
        </div>
    );
}

export default SubscriptionListItem;